import { createCodedError } from '~/common/errors/CodedError';
import { JsonApiErrorResponse } from '~/redux/api/ApiTypes';
import { HttpValidationError } from '~/redux/api/types/sylvanus/internal';
import { testIsAxiosError } from '~/redux/api/utils';
import { esignature } from '~/services/serviceInstances';

export interface Request {
  integrationId: string;
  token_ids: string[];
}

export type RevokeEsignatureIntegrationUsersResponse = void;

type ErrorResponse = JsonApiErrorResponse | HttpValidationError;

type ServerRequest = {
  data: {
    data: {
      type: string;
      attributes: {
        token_ids: string[];
      };
    };
  };
};
export const revokeIntegrationUsers = async (
  request: Request,
): Promise<RevokeEsignatureIntegrationUsersResponse> => {
  const serverRequest = mapRequest(request);
  try {
    await esignature.remove(
      `/integrations/${request.integrationId}/users`,
      serverRequest,
    );
  } catch (error) {
    if (testIsAxiosError<ErrorResponse>(error) && error.response) {
      const { status } = error.response;
      const responseData = error.response.data;

      if (
        status === 422 &&
        'detail' in responseData &&
        Array.isArray(responseData.detail)
      ) {
        const validationError = responseData.detail[0];
        const message = validationError?.msg || 'Validation error';
        throw createCodedError({
          message,
          statusCode: status,
          title: 'Validation Error',
        });
      }

      if ('errors' in responseData && Array.isArray(responseData.errors)) {
        const errorResponse = responseData.errors[0];
        throw createCodedError({
          message: errorResponse.detail ?? errorResponse.title,
          statusCode: errorResponse.status,
          title: errorResponse.title,
        });
      }
    }
    throw error;
  }
};

const mapRequest = (request: Request): ServerRequest => {
  return {
    data: {
      data: {
        type: 'auth-identities',
        attributes: {
          token_ids: request.token_ids,
        },
      },
    },
  };
};
